<template>
  <div class="design-grid" :class="{ 'show-grid': showGrid }">
    <div v-for="n in 12" :key="n" class="grid-column" />
  </div>
</template>

<script setup>
const showGrid = ref(false);

const toggleGrid = (event) => {
  if (event.key === "g" || event.key === "G") {
    showGrid.value = !showGrid.value;
  }
};

onMounted(() => {
  window.addEventListener("keydown", toggleGrid);
});

onUnmounted(() => {
  window.removeEventListener("keydown", toggleGrid);
});
</script>

<style lang="scss" scoped>
.design-grid {
  --columns: 12;
  --margin: 2.4rem;
  --gutter: 2.4rem;

  position: fixed;
  height: 100%;
  inset: 0;
  z-index: 10;
  width: 100%;
  padding: 0 var(--margin);

  pointer-events: none;
  display: flex;

  gap: 1.2rem;

  @include desktop {
    gap: 2.4rem;
  }

  .grid-column {
    flex: 1 1 auto;
    background-color: rgba(255, 0, 0, 0.1);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &.show-grid .grid-column {
    opacity: 1;
  }
}

// Media queries pour la responsivité
@media (max-width: 1024px) {
  .design-grid {
    --margin: 1.2rem;
    --gutter: 1.2rem;
  }
}
</style>
